import creator from '@utils/creator.js';

import OnLoaded from '@components/Tracking/OnLoaded';
import ClickPush from '@components/Tracking/ClickPush';
import TrackingForm from '@components/Tracking/TrackingForm';
import TrackingCart from '@components/Tracking/TrackingCart';
import UserLoadAccountPage from '@components/Tracking/UserLoadAccountPage';
import UserLoad from '@components/Tracking/UserLoad.js';
import SignInEvent from '@components/Tracking/SignInEvent';
import SignInEventPostConnect from '@components/Tracking/SignInEventPostConnect';
import FormSubmit from '@components/Tracking/FormSubmit';
import ClickDiscoverLoyaltyProgram from '@components/Tracking/ClickDiscoverLoyaltyProgram';
import ClickRegisterLoyaltyProgram from '@components/Tracking/ClickRegisterLoyaltyProgram';

function ClrzAppInit() {
	ClrzApp.OnLoaded = OnLoaded;
	ClrzApp.ClickPush = creator('.js-gtm-click-push', ClickPush);
	ClrzApp.TrackingForm = creator('.js-tracking-form', TrackingForm);
	ClrzApp.TrackingCart = creator('.js-tracking-cart', TrackingCart);
	ClrzApp.UserLoad = creator('.js-dataLayer-userLoad', UserLoad);
	ClrzApp.UserLoadAccountPage = creator(
		'.js-dataLayer-userLoad-accountPage',
		UserLoadAccountPage,
	);
	ClrzApp.SignInEvent = creator('.js-dataLayer-signin', SignInEvent);
	ClrzApp.SignInEventPostConnect = creator(
		'.js-dataLayer-signin-postConnect',
		SignInEventPostConnect,
	);
	ClrzApp.FormSubmit = creator('.js-dataLayer-formSubmit', FormSubmit);
	ClrzApp.ClickDiscoverLoyaltyProgram = creator(
		'.js-dataLayer-discover-loyalty',
		ClickDiscoverLoyaltyProgram,
	);
	ClrzApp.ClickRegisterLoyaltyProgram = creator(
		'.js-dataLayer-register-loyalty',
		ClickRegisterLoyaltyProgram,
	);
}

ClrzAppInit();
